import React, { useEffect, useState } from 'react'
import { Modal, ModalBody, Text, InjectedModalProps, Flex } from '@pancakeswap/uikit'
import { useTranslation } from 'contexts/Localization'
import { useXrpl, fetchTransactionsByAddress, BithompTransaction } from '../../../xrpl'
import Transaction from './Transaction'
import ConnectWalletButton from '../../ConnectWalletButton'

function renderTransactions(transactions: BithompTransaction[]) {
  return (
    <Flex flexDirection="column">
      {transactions.map((tx) => {
        return <Transaction key={tx.id} tx={tx} />
      })}
    </Flex>
  )
}

const TransactionsModal: React.FC<InjectedModalProps> = ({ onDismiss }) => {
  const { account } = useXrpl()
  const { t } = useTranslation()
  const [transactions, setTransactions] = useState<BithompTransaction[]>([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')

  useEffect(() => {
    const loadTransactions = async () => {
      if (!account) {
        setTransactions([])
        return
      }
      setLoading(true)
      setError('')
      try {
        const data = await fetchTransactionsByAddress(account)
        setTransactions(data)
      } catch (fetchError) {
        setError(fetchError.message || 'Failed to load transactions')
        setTransactions([])
      } finally {
        setLoading(false)
      }
    }
    loadTransactions()
  }, [account])

  return (
    <Modal title={t('Recent Transactions')} headerBackground="gradients.cardHeader" onDismiss={onDismiss}>
      {account ? (
        <ModalBody>
          {loading ? (
            <Text>{t('Loading')}</Text>
          ) : error ? (
            <Text color="failure">{error}</Text>
          ) : transactions.length ? (
            renderTransactions(transactions)
          ) : (
            <Text>{t('No recent transactions')}</Text>
          )}
        </ModalBody>
      ) : (
        <ConnectWalletButton />
      )}
    </Modal>
  )
}

export default TransactionsModal
